import AssetApi from "../../services/api/Asset";
import ActionTypes from "./ActionTypes";
import { setLoader, setStatus } from "./User";
import Errors from "../../constants/Errors.json";
import _ from "lodash-es";
import { isUrlValid } from "../../utils";

function handleError(err) {
  console.log("error in feature actions:", err);
}

export const setAssetList = (payload) => {
  return {
    type: ActionTypes.SET_ASSET_LIST,
    payload,
  };
};

export const setActiveAsset = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_ASSET,
    payload,
  };
};

export const setActiveFilters = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_FILTERS,
    payload,
  };
};

export const setCurrentPageAsset = (payload) => {
  return {
    type: ActionTypes.SET_CURRENT_PAGE_ASSET,
    payload,
  };
};

export const resetState = (payload) => {
  return {
    type: ActionTypes.RESET_STATE_ASSET,
    payload,
  };
};

const validateData = (data) => {
  const images = data.images?.split(",");

  if (data.icon_image && !isUrlValid([data.icon_image])) {
    return {
      status: false,
      message: "Icon image is invalid!",
    };
  } else if (!isUrlValid(images) && data.images) {
    return {
      status: false,
      message: "Images are invalid!",
    };
  }
  return {
    status: true,
  };
};

export const getAssetList =
  (filters = {}, pageRequest = {}) =>
  async (dispatch) => {
    try {
      let response = await AssetApi.getAssetList();
      console.log(response, "response");
      dispatch(setLoader(false));
      if (response) {
        dispatch(setAssetList(response));
      }
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const getAsset =
  (id, assetList = []) =>
  async (dispatch) => {
    try {
      dispatch(setLoader(true));
      const response = assetList.find((obj) => obj.id == id);
      dispatch(setLoader(false));
      if (response) {
        dispatch(setActiveAsset(response));
      }
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const createOrUpdateAsset = (data) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    const isDataValid = validateData(data);
    if (!isDataValid.status) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: isDataValid.message,
        })
      );
      return;
    }
    let response = await AssetApi.createOrUpdateAsset({
      assets: [
        {
          ...data,
          amount: parseFloat(data.amount),
          chargeable_amount: parseFloat(data.chargeable_amount),
          is_active: data.is_active,
          id: parseInt(data.id || 0),
        },
      ],
    });
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "success",
        message: "Asset updated successfully",
      })
    );
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
